import { Card, variables } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const RiderCard = styled(Card)`
  min-width: 22rem;
  max-width: 42.857rem;
  flex-grow: 1;

  div:nth-child(2) {
    width: 100%;
  }

  @media (max-width: 1240px) {
    max-width: unset;
  }

  ${variables.mediaQuery.lessThan('tablet')`   
    min-width: 100%;
    max-width: 100%;
  `}
`;
